import { createSlice } from '@reduxjs/toolkit'
import { channelTableModifiedDate } from '../../Constants/TableConfiguration'

export const channelSlice = createSlice({
  name: 'channel',
  initialState: {
    channelsSettingsView: '',
    channelList: [],
    channelChangeModal: false,
    sectorsFilter: [],
    supergroupsFilter: [],
    channelDataChanges: [],
    countriesList: [],
  },
  reducers: {
    setChannelList: (state, action) => {
      state.channelList = action.payload
    },
    setChannelTableFilters: (state, action) => {
      state.sectorsFilter = action.payload.sectors ? action.payload.sectors : []

      state.supergroupsFilter = action.payload.superGroups ? action.payload.superGroups : []
    },
    setChannelPropertyToSave: (state, action) => {
      const channel = state.channelList.find(x => x.name === action.payload.name)
      const savedIndex = state.channelList.findIndex(x => x.name === action.payload.name)

      const savedChannelCopy = { ...channel }
      savedChannelCopy[action.payload.field] = action.payload.value
      savedChannelCopy[channelTableModifiedDate] = action.payload.date

      if (state.channelDataChanges.indexOf(action.payload.name) === -1) {
        state.channelDataChanges = [...state.channelDataChanges, action.payload.name]
      }

      if (savedIndex !== -1) {
        state.channelList.splice(savedIndex, 1, savedChannelCopy)
      }
    },

    resetChannelChanges: state => {
      state.channelDataChanges = []
    },
    setCommissionsToSave: (state, action) => {
      const channel = {
        ...state.channelList.find(x => x.name === action.payload.name),
      }
      const channelIndex = state.channelList.findIndex(x => x.name === action.payload.name)
      let commissions = channel.commissions || []
      const newCommission = action.payload.commission

      if (state.channelDataChanges.indexOf(action.payload.name) === -1) {
        state.channelDataChanges = [...state.channelDataChanges, action.payload.name]
      }

      if (newCommission.threshold || newCommission.threshold === 0) {
        const commissionAlreadyInsert = commissions.find(
          x =>
            x.threshold &&
            action.payload.oldThreshold === x.threshold &&
            newCommission.sectorId === x.sectorId &&
            newCommission.supergroupId === x.supergroupId,
        )

        if (newCommission.threshold !== 0) {
          if (commissionAlreadyInsert) {
            const commissionIndex = commissions.findIndex(
              x =>
                x.threshold &&
                action.payload.oldThreshold === x.threshold &&
                newCommission.sectorId === x.sectorId &&
                newCommission.supergroupId === x.supergroupId,
            )
            commissions.splice(commissionIndex, 1, newCommission)
          } else {
            commissions.push(newCommission)
          }

          //need to update threshold for commission with sector and supergroup in order to keep same values
          if (!newCommission.sectorId && !newCommission.supergroupId) {
            commissions.forEach(commission => {
              if (commission.threshold === action.payload.oldThreshold) {
                commission.threshold = newCommission.threshold
              }
            })
          }
        } else {
          commissions = commissions.filter(x => x.threshold !== action.payload.oldThreshold)
        }
      } else {
        const commissionAlreadyInsert = commissions.find(
          x => !x.threshold && x.sectorId === newCommission.sectorId && x.supergroupId === newCommission.supergroupId,
        )
        if (commissionAlreadyInsert) {
          const commissionIndex = commissions.findIndex(
            x => !x.threshold && x.sectorId === newCommission.sectorId && x.supergroupId === newCommission.supergroupId,
          )
          commissions.splice(commissionIndex, 1, newCommission)
        } else {
          commissions.push(newCommission)
        }
      }

      channel[channelTableModifiedDate] = action.payload.date
      channel.commissions = commissions

      if (channelIndex !== -1) {
        state.channelList.splice(channelIndex, 1, channel)
      }
    },
    removeThreshold: (state, action) => {
      const channel = {
        ...state.channelList.find(x => x.name === action.payload.name),
      }
      const channelIndex = state.channelList.findIndex(x => x.name === action.payload.name)

      const commissions = channel.commissions || []

      if (state.channelDataChanges.indexOf(action.payload.name) === -1) {
        state.channelDataChanges = [...state.channelDataChanges, action.payload.name]
      }

      channel.commissions = commissions.filter(x => x.threshold !== action.payload.threshold)

      channel[channelTableModifiedDate] = action.payload.date

      if (channelIndex !== -1) {
        state.channelList.splice(channelIndex, 1, channel)
      }
    },
    setCountriesList: (state, action) => {
      state.countriesList = action.payload
    },
    setMultishippingToSave: (state, action) => {
      const { name, payloadMultiShipping, date } = action.payload
      const channel = {
        ...state.channelList.find(x => x.name === name),
      }
      const channelIndex = state.channelList.findIndex(x => x.name === name)

      let multiShipping = channel.multiShipping || []
      const newMultiShipping = action.payload.multiShipping

      if (state.channelDataChanges.indexOf(name) === -1) {
        state.channelDataChanges = [...state.channelDataChanges, name]
      }
      let index = multiShipping.findIndex(item => item.iso === newMultiShipping.iso)

      if (index !== -1) {
        multiShipping.splice(index, 1, newMultiShipping)
      } else {
        multiShipping.push(newMultiShipping)
      }

      channel[channelTableModifiedDate] = date
      channel.multiShipping = multiShipping.filter(x => x.amount !== null)

      if (channelIndex !== -1) {
        state.channelList.splice(channelIndex, 1, channel)
      }
    },
    eraseChannelMultishipping: (state, action) => {
      const channelName = action.payload
      const index = state.channelList.findIndex(x => x.name === channelName)
      if (
        index !== -1 &&
        Array.isArray(state.channelList[index].multiShipping) &&
        state.channelList[index].multiShipping.length > 0
      ) {
        if (state.channelDataChanges.indexOf(channelName) === -1) {
          state.channelDataChanges = [...state.channelDataChanges, channelName]
        }
        const updatedChannel = {
          ...state.channelList[index],
          multiShipping: [],
        }

        state.channelList[index] = updatedChannel
      }
    },
  },
})

export const {
  setCountriesList,
  setChannelList,
  setChannelPropertyToSave,
  resetChannelChanges,
  setCommissionsToSave,
  setChannelTableFilters,
  removeThreshold,
  setMultishippingToSave,
  eraseChannelMultishipping,
} = channelSlice.actions

export default channelSlice.reducer
